module.exports = __webpack_public_path__ + "static/media/chat-bubble-icon.4bebdb22.svg";